/* jshint ignore:start */

var ContestsManager = (function($) {

    var instance;

    function init() {

        var _$contestsFilter;

        function hasDataToFilter()
        {
            var category = $('.js-bulletin-category').val();

            if (category != 0) {
                return true;
            }

            return false;
        }



        function initFilterContests()
        {
            var $contestsFilterBtn = $('.js-filter-contests-btn');
            $contestsFilterBtn.on('click', function(e) {
                e.preventDefault();

                _$contestsFilter.submit();

            });

        }

        return {

            init: function() {

                _$contestsFilter = $('.js-form-filter-contests');

                if (_$contestsFilter.length) {
                    initFilterContests();
                }
            }
        };
    }


    return {

        getInstance: function() {

            if (!instance) {
                instance = init();
            }

            return instance;
        }
    };
})(jQuery);
/* jshint ignore:end */
